import { render, staticRenderFns } from "./assess.vue?vue&type=template&id=baa10c5e&scoped=true"
import script from "./assess.vue?vue&type=script&lang=ts"
export * from "./assess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa10c5e",
  null
  
)

export default component.exports